import interfaceSection from "../interface/InterfaceSection";

export const EMPTY_SECTION: interfaceSection = {
  sectionId: 0,
  sectionName: ''
}